export const REGISTRATIONS_DETAIL_RESET = 'REGISTRATIONS_DETAIL_RESET';
